import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InfiniteScrollKey, LIMIT } from "../const";

interface ControlPageProps {
  offset?: number;
  limit?: number;
}

interface MultiScrollState {
  default: ControlPageProps;
  [key: string]: ControlPageProps;
}

const initialState: MultiScrollState = {
  default: { offset: 0, limit: LIMIT },
};

const controlListInfinitiveScrollSlice = createSlice({
  name: "controlListInfinitiveScroll",
  initialState,
  reducers: {
    resetControlPage: (
      state,
      action: PayloadAction<string | null | undefined> | null | undefined
    ) => {
      const id = action?.payload ?? InfiniteScrollKey.DEFAULT;
      if (state[id]) {
        state[id] = { offset: 0, limit: LIMIT };
      }
    },
    setupControlPage: (
      state,
      action: PayloadAction<{ id?: string; limit: number }>
    ) => {
      const { id = InfiniteScrollKey.DEFAULT, limit } = action.payload;
      if (!state[id]) {
        state[id] = { offset: 0, limit };
      } else {
        state[id].limit = limit;
      }
    },
    updateControlPage(
      state,
      action: PayloadAction<{ id?: string; limit: number }>
    ) {
      const { id = InfiniteScrollKey.DEFAULT, limit = LIMIT } = action.payload;
      if (!state[id]) {
        state[id] = { offset: 0, limit };
      } else {
        state[id].limit = limit;
      }
    },
    loadMoreList(state, action: PayloadAction<{ id?: string }>) {
      const { id = InfiniteScrollKey.DEFAULT } = action.payload;
      if (state[id]) {
        state[id].offset += state[id].limit;
      }
    },
    resetControlPageFilter: (
      state,
      action: PayloadAction<{ id?: string; limit: number }>
    ) => {
      const { id = InfiniteScrollKey.DEFAULT, limit } = action.payload;

      state[id] = {
        offset: 0,
        limit: limit,
      };
    },
  },
});

export const {
  resetControlPage,
  setupControlPage,
  updateControlPage,
  loadMoreList,
  resetControlPageFilter,
} = controlListInfinitiveScrollSlice.actions;

export default controlListInfinitiveScrollSlice.reducer;
